'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Text2 = require('./Text');

var _Text3 = _interopRequireDefault(_Text2);

var _images = require('../utils/images');

var _styles = require('../types/styles');

var _images2 = require('../types/images');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    BaseImage = _window.Image;
var ImageStyle = _styles.ImageStyle,
    TextStyle = _styles.TextStyle;
var Dimension = _images2.Dimension;


var defaultStyle = {
  fontSize: '1px',
  color: 'transparent'
};

var Image = function (_Text) {
  _inherits(Image, _Text);

  function Image(konsul) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, konsul));

    _this.children = ['+'];
    _this.requestedStyle = {};
    _this.style = defaultStyle;


    _this.image = new BaseImage();
    _this.image.addEventListener('load', function (_ref4) {
      var target = _ref4.target;
      var width = target.width,
          height = target.height;

      _this.dimension = { width: width, height: height };

      if (!Dimension(_this.dimension)) {
        throw new TypeError('Value of "this.dimension" violates contract.\n\nExpected:\nDimension\n\nGot:\n' + _inspect(_this.dimension));
      }

      if (width !== _this.requestedStyle.width || height !== _this.requestedStyle.height) {
        _this.updateStyle();
      }
    });
    return _this;
  }

  _createClass(Image, [{
    key: 'setSource',
    value: function setSource(url) {
      if (!(typeof url === 'string')) {
        throw new TypeError('Value of argument "url" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(url));
      }

      this.url = url;
      this.image.src = this.url;

      if (this.style !== defaultStyle) {
        this.updateStyle();
      }
    }
  }, {
    key: 'setStyle',
    value: function setStyle() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!ImageStyle(style)) {
        throw new TypeError('Value of argument "style" violates contract.\n\nExpected:\nImageStyle\n\nGot:\n' + _inspect(style));
      }

      this.requestedStyle = style;

      if (!ImageStyle(this.requestedStyle)) {
        throw new TypeError('Value of "this.requestedStyle" violates contract.\n\nExpected:\nImageStyle\n\nGot:\n' + _inspect(this.requestedStyle));
      }

      this.updateStyle();
    }
  }, {
    key: 'updateStyle',
    value: function updateStyle() {
      var _calculateDimensions = (0, _images.calculateDimensions)(this.requestedStyle, this.dimension),
          width = _calculateDimensions.width,
          height = _calculateDimensions.height;

      if (!Dimension({ width: width, height: height })) {
        throw new TypeError('Value of "{\n  width,\n  height\n}" violates contract.\n\nExpected:\nDimension\n\nGot:\n' + _inspect({ width: width, height: height }));
      }

      var textStyle = _extends({}, this.requestedStyle, defaultStyle, {
        padding: Math.floor(height / 2) + 'px ' + Math.floor(width / 2) + 'px',
        lineHeight: height + 'px',
        background: 'url(\'' + this.url + '\')',
        backgroundSize: width + 'px ' + height + 'px'
      });

      if (!TextStyle(textStyle)) {
        throw new TypeError('Value of variable "textStyle" violates contract.\n\nExpected:\nTextStyle\n\nGot:\n' + _inspect(textStyle));
      }

      this.konsul.emit('shouldRender');

      _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'setStyle', this).call(this, textStyle);
    }
  }]);

  return Image;
}(_Text3.default);

exports.default = Image;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : _typeof(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = Object.keys(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../lib/widgets/Image.js
// module id = 695
// module chunks = 0